import React, { useEffect, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-confirm-alert/src/react-confirm-alert.css'
import {SideBar} from "./sidebar/SideBar";
import './App.css'
import { BrowserRouter,Route,Routes} from "react-router-dom";
import Visitorlog from "./pages/visitorlog/visitorlog";
import Homepg from "./pages/livetable/homepg";
import Entryform from "./pages/entryform/EntryForm";
import Exitform from "./pages/Exitform/Exitform";
import Login from "./pages/login/Login"
import Protectedroutes from "./Protectedroutes";
export default function App() {
  // sessionStorage.setItem("Apipathurl","https://vrms.hexbss.xyz/Sandbox/");
  // sessionStorage.setItem("userid","3");
  // sessionStorage.setItem("orgdbname","VRApp_OrgDb_Tester");
  // sessionStorage.setItem("login","true");
  return (
 
    <BrowserRouter>
        <Routes>
        <Route path="/Entryform" element={<Entryform/>} />
        <Route path="/Exitform" element={<Exitform/>} />
          <Route path="/login" element={<Login/>} />
          <Route element={<Protectedroutes />}>
            <Route path="/" element={<SideBar />}>
              <Route index path="/" element={<Homepg />} />
              <Route exact path="/HomePage" element={<Homepg />} />
              <Route path="/Visitorlogs" element={<Visitorlog />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
   
  );
}
